module.exports = __webpack_public_path__ + "img/greencart.a5cc3ba1.svg";